import constants from '@/api';

const initialState = () => ({
	fileMetaEditorDialog: false,
	mailMeta: {},
	selectedFile: {},
	currentLogs: [],
	characterHeaderSequence: [],
	extractedIdHeaders: [],
	parserConfig: {},
	selectedFilesForExtraction: [],
});
export default {
	namespaced: true,
	state: initialState(),
	mutations: {
		openFileMetaDialog(state) {
			state.fileMetaEditorDialog = true;
		},
		closeFileMetaDialog(state) {
			state.fileMetaEditorDialog = false;
		},
		loadMailMeta(state, mm) {
			state.mailMeta = JSON.parse(JSON.stringify(mm));
		},
		setSelectedFile(state, sf) {
			state.selectedFile = JSON.parse(JSON.stringify(sf));
		},
		setCurrentLogs(state, logs) {
			state.currentLogs = logs;
		},
		setIdHeaders(state, headers) {
			state.extractedIdHeaders = headers;
		},
		setParserConfig(state, parserConfig) {
			state.parserConfig = parserConfig;
		},
		refreshStockistListEmitter(state) {},
		failure: (s, msg) => {
			console.log('[failure] ', msg);
		},
		setCharacterHeaderSequence(state, charSequence) {
			state.characterHeaderSequence = charSequence;
		},
		setSelectedFilesForExtraction(state, filesArray) {
			state.selectedFilesForExtraction = filesArray;
		},
		resetState(state) {
			const initial = initialState();
			Object.keys(initial).forEach(key => {
				state[key] = initial[key];
			});
		},
	},
	actions: {
		getMailMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: payload,
					url: constants.REJECTED_META,
				},
				{
					root: true,
				}
			)
				.then(data => {
					if (data.ok) {
						commit('loadMailMeta', data.files);
						return data;
					} else {
						fail(data.message || 'Failed to load Mail meta');
						return false;
					}
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		verifyMeta: ({ commit, dispatch, state }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.FILE_EXTRACTION_REJECT_VERIFY_CONFIG,
				},
				{
					root: true,
				}
			)
				.then(data => {
					console.log(data);
					if (data.ok) {
						let tempReturnableArray = [];
						for (let i of data.returnable) {
							if (i.filename != state.selectedFile.filename) {
								tempReturnableArray.push(i);
							} else {
								tempReturnableArray.unshift(i);
							}
						}
						commit('setCurrentLogs', [
							{
								extracted: tempReturnableArray.length,
								extractedFiles: tempReturnableArray.map(e => e.filename),
							},
							...tempReturnableArray,
						]);
					} else {
						commit('setCurrentLogs', [
							{
								extracted: data.returnable.length,
								extractedFiles: data.returnable.map(e => e.filename),
								errors: data.errors.length,
								erroredFiles: data.errors.map(e => e.filename),
								total: data.returnable.length + data.errors.length,
							},
							...data.returnable,
							...data.errors,
						]);
					}
					return data.returnable.length > 0;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		extractAndSaveMeta: ({ commit, dispatch }, payload) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: payload,
					url: constants.FILE_EXTRACTION_REJECT_EXTRACT_AND_SAVE_CONFIG,
				},
				{
					root: true,
				}
			)
				.then(data => {
					console.log(data);
					if (data.ok) {
						commit('setCurrentLogs', data.returnable);
					} else {
						commit('setCurrentLogs', [...data.returnable, ...data.errors]);
					}
					return data.returnable.length > 0;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		getAlternateTransform: ({ commit, dispatch }, transformParams) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: transformParams,
					url: constants.UTILITY_ALTERNATE_TRANSFORMED_FILE,
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		getFileJSON: (
			{ commit, dispatch },
			{ renderMode, filePathURL, cancelToken }
		) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: {},
					url:
						renderMode == 'parsed'
							? constants.UTILITY_PARSED_FILE + filePathURL
							: constants.UTILITY_TRANSFORMED_FILE + filePathURL,
					cancelToken,
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		getHeaderMapping: ({ commit, dispatch }, hm) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: hm,
					url: constants.UTILITY_GET_MAPPING,
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load header mapping');
				});
		},
		registerHeaderMapping: ({ commit, dispatch }, hm) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: hm,
					url: constants.UTILITY_REGISTER_MAPPING,
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data.ok;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load header mapping');
				});
		},
		lockFile: ({ commit, dispatch }, mailMetaId) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: {
						_id: mailMetaId,
					},
					url: constants.FILE_EXTRACTION_LOCK_FILE,
				},
				{
					root: true,
				}
			)
				.then(data => {
					if (data.ok) {
						return data.lock;
					} else {
						commit(
							'openSnackbar',
							{
								text: 'Failed to check file status',
							},
							{
								root: true,
							}
						);
						return true;
					}
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load header mapping');
				});
		},
		unlockFile: ({ commit, dispatch }, mailMetaId) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: {
						_id: mailMetaId,
					},
					url: constants.FILE_EXTRACTION_UNLOCK_FILE,
				},
				{
					root: true,
				}
			)
				.then(data => {
					if (data.ok) {
						return data.lock;
					} else {
						commit(
							'openSnackbar',
							{
								text: 'Failed to update file status',
							},
							{
								root: true,
							}
						);
						return true;
					}
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load header mapping');
				});
		},
		downloadFile: ({ commit, dispatch, state }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url:
						constants.UTILITY_OG_FILE +
						'?uuid=' +
						state.selectedFile.filename.split('.')[0],
					responseType: 'blob',
				},
				{
					root: true,
				}
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{
								text: 'Starting Download',
							},
							{
								root: true,
							}
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', state.selectedFile.filename); //or any other extension
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{
								text: 'Could not start download',
							},
							{
								root: true,
							}
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					console.log('Yo ', err);
					commit(
						'openSnackbar',
						{
							text: 'Could not start download',
						},
						{
							root: true,
						}
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
		downloadActualFile: ({ commit, dispatch, state }) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'fileDownload_API_Call',
				{
					method: 'get',
					params: {},
					url:
						constants.UTILITY_OG_FILE +
						'?uuid=' +
						state.selectedFile.originalFilename.split('.')[0],
					responseType: 'blob',
				},
				{
					root: true,
				}
			)
				.then(({ data, response }) => {
					if (response.status === 200) {
						commit(
							'openSnackbar',
							{
								text: 'Starting Download',
							},
							{
								root: true,
							}
						);
						const url = window.URL.createObjectURL(new Blob([data]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', state.selectedFile.originalFilename); //or any other extension
						document.body.appendChild(link);
						link.click();
						return;
					} else {
						commit(
							'openSnackbar',
							{
								text: 'Could not start download',
							},
							{
								root: true,
							}
						);
						fail(data.message || 'Failed to start download');
						return;
					}
				})
				.catch(err => {
					console.log('Yo ', err);
					commit(
						'openSnackbar',
						{
							text: 'Could not start download',
						},
						{
							root: true,
						}
					);
					fail(err.toString() || 'Failed to Download Core Data File');
				});
		},
		getFileMeta: ({ commit, dispatch }, metaId) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: {
						metaUsed: metaId,
					},
					url: constants.UTILITY_FILE_META,
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		getExtractedOutput: ({ commit, dispatch }, params) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'get',
					params: params,
					url: constants.UTILITY_EXTRACTED_OUTPUT,
				},
				{
					root: true,
				}
			)
				.then(data => {
					return data;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load the Master Data Processes');
				});
		},
		forceRejectFilesFromBackend: ({ commit, dispatch }, files) => {
			let fail = msg => commit('failure', msg);
			return dispatch(
				'apiCall',
				{
					method: 'post',
					data: files,
					url: constants.UTILITY_FORCE_REJECT_FILE,
				},
				{ root: true }
			)
				.then(data => {
					return data.ok;
				})
				.catch(err => {
					console.log('Yo ', err);
					fail(err.toString() || 'Failed to load header mapping');
				});
		},
	},
	getters: {
		fileMetaEditorDialog: state => state.fileMetaEditorDialog,
		mailMeta: state => state.mailMeta,
		selectedFile: state => state.selectedFile,
		currentLogs: state => state.currentLogs,
		extractedIdHeaders: state => state.extractedIdHeaders,
		parserConfig: state => state.parserConfig,
		characterHeaderSequence: state => state.characterHeaderSequence,
		selectedFilesForExtraction: state => state.selectedFilesForExtraction,
	},
};
